import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// Copyright 2017-2021 @polkadot/metadata authors & contributors
// SPDX-License-Identifier: Apache-2.0
import * as substrate from "./substrate.mjs";
/** @internal */

export function getStorage(registry, metaVersion) {
  return {
    substrate: Object.entries(substrate).reduce(function (storage, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          fn = _ref2[1];

      storage[key] = fn(registry, metaVersion);
      return storage;
    }, {})
  };
}